import { AnyObject } from "global";
import CommonApi from "shared/enums/CommonApi";
import { usePostApiData } from "shared/datalayer";

export function useResendInvoicePayerPaymentReminder(
  registrationParticipantId?: string,
  invoicePaymentRequestId?: string
) {
  return usePostApiData<void, AnyObject>(CommonApi.RESEND_INVOICE_PAYMENT_REMINDER_TO_PAYER, {
    clientOptions: { params: { registrationParticipantId, invoicePaymentRequestId } }
  });
}
